import { Capacitor } from '@capacitor/core';
export function isNativeApp() {
    return Capacitor.isNative ?? false;
}
export function isSharkBrowser() {
    return window.navigator.userAgent.includes('ga-meow-shark-browser');
}
export function isFloatingLivePlayerEmbed() {
    return window.location.search.includes('floating=1');
}
export function isPWA() {
    return !isNativeApp() && !isSharkBrowser() && !window.navigator.userAgent.includes('ga-meow') && !!(window.matchMedia?.('(display-mode: standalone)').matches ||
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        window.navigator.standalone ||
        (!!window.HwWebViewJSI &&
            !window.HwDevice?.getOaid) ||
        window.location.search.includes('isPWA=1'));
}
export async function getClientHintJsonString(clientHint) {
    const highEntropyValues = await clientHint.getHighEntropyValues(['model', 'platformVersion', 'fullVersionList']);
    const result = {
        brands: clientHint.brands,
        mobile: clientHint.mobile,
        platform: clientHint.platform,
        highEntropyValues
    };
    return JSON.stringify(result);
}
export const getNativePlatform = () => Capacitor.getPlatform();
export const isIOSDevice = () => /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const getSafariVersion = () => {
    const userAgent = navigator.userAgent;
    const isSafari = userAgent.includes('Safari/') && !/Chrome|Chromium|CriOS|Edg/.test(userAgent);
    if (!isSafari) {
        return null;
    }
    const match = userAgent.match(/Version\/(\d+)\.(\d+)/);
    if (match) {
        return `${match[1]}.${match[2]}`;
    }
    return null;
};
//# sourceMappingURL=detect.js.map